import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from "@microsoft/signalr";

class SignalRService {
  private static instance: SignalRService;
  public connection: HubConnection;
  private isConnecting = false;

  private constructor() {
    const baseUrl =
      import.meta.env.MODE === "development"
        ? import.meta.env.VITE_LOCAL_SIGNALR_BASE_URL ||
          "http://localhost:5130/"
        : import.meta.env.VITE_SIGNALR_BASE_URL ||
          "https://breign.azurewebsites.net/";

    // Ensure baseUrl ends with a slash
    const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl : baseUrl + "/";
    const hubUrl = `${normalizedBaseUrl}schoolHub`;

    this.connection = new HubConnectionBuilder()
      .withUrl(hubUrl, {
        accessTokenFactory: () => localStorage.getItem("token") || "",
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .configureLogging(LogLevel.Information)
      .build();
  }

  public static getInstance(): SignalRService {
    if (!SignalRService.instance) {
      SignalRService.instance = new SignalRService();
    }
    return SignalRService.instance;
  }

  public async connect(): Promise<void> {
    if (this.connection.state === "Connected" || this.isConnecting) {
      return;
    }

    this.isConnecting = true;
    try {
      await this.connection.start();
    } catch (error) {
    } finally {
      this.isConnecting = false;
    }
  }

  public async disconnect(): Promise<void> {
    if (this.connection.state === "Connected") {
      await this.connection.stop();
    }
  }

  public async joinSchoolGroup(
    userId: string,
    schoolId: string
  ): Promise<void> {
    if (this.connection.state !== "Connected") return;
    try {
      await this.connection.invoke("JoinUserGroup", userId, schoolId);
    } catch (error) {}
  }
}

export const signalRService = SignalRService.getInstance();
